module.exports = __webpack_public_path__ + "img/logo-white-horizontal.1505d215.svg";